export interface BaseUuidEntity {
  id?: string;
  version?: number;
  createdBy?: string;
  modifiedBy?: string;
  createdOn?: number;
  modifiedOn?: number;
}

export function createBaseUuidEntity(params: Partial<BaseUuidEntity>) {
  return {
    id: params && params.id,
    version: params && params.version,
    createdBy: params && params.createdBy,
    modifiedBy: params && params.modifiedBy,
    createdOn: params && params.createdOn,
    modifiedOn: params && params.modifiedOn,
  } as BaseUuidEntity;
}

export function createBaseUuidEntityForm(params?: Partial<BaseUuidEntity>) {
  return {
    id: [params && params.id],
    version: [params && params.version || 0],
    createdBy: [params && params.createdBy],
    modifiedBy: [params && params.modifiedBy],
    createdOn: [params && params.createdOn],
    modifiedOn: [params && params.modifiedOn],
  };
}
